import React from 'react';
import Link from 'Components/Link';

import Button from 'Components/Button';
import CollectionListItem from 'Components/CollectionListItem';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const ClassesListItem = props => {
  const studentCount = ({ student_ids }) => (
    <div className="CollectionListItem__student-count">
      <div className="CollectionListItem__student-count-number">
        {student_ids.length}
      </div>
      <div className="CollectionListItem__student-count-label">
        <ConnectedFormattedMessage
          id="classes_list_item.count_label"
          values={{ result_count: student_ids.length }}
        />
      </div>
    </div>
  );

  const actionButton = (
    <Button
      label={<ConnectedFormattedMessage id="classes_list_item.action_button" />}
      buttonType="secondary-mono"
      additionalClasses=" CollectionListItem__action-button"
      clickHandler={() => null}
    />
  );

  return (
    <Link
      to={`/classes/${props.id}`}
      className="CollectionListItem__link is-hoverable-parent"
    >
      <CollectionListItem
        {...props}
        type="classes"
        actionButton={actionButton}
        countColumn={studentCount(props)}
      />
    </Link>
  );
};

export default ClassesListItem;
